export default "__VITE_ASSET__Cs9mCY9e__"